import ads from './ads';
import valuation from './valuation';

export { ads, valuation };



// WEBPACK FOOTER //
// ./src/ducks/index.js